import CurrencyService from '@/services/currency.service'
export default {
  getCurrencies ({ commit }) {
    commit('SET_LOADING_CURRENCY', true)
    return CurrencyService.getCurrencies()
      .then(currencies => commit('SET_CURRENCIES', currencies.data))
      .catch(() => commit('SET_CURRENCIES', []))
  },
  getCurrencyRates ({ commit }) {
    commit('SET_LOADING_CURRENCY', true)
    return CurrencyService.getCurrencyRates()
      .then(currencies => commit('SET_CURRENCY_RATES', currencies.data))
      .catch(() => commit('SET_CURRENCY_RATES', []))
  },
  getCurrencyRatesAllStore ({ commit }, storeIds) {
    commit('SET_LOADING_CURRENCY', true)
    return CurrencyService.getCurrencyRatesAllStore(storeIds)
      .then(currencies => commit('SET_CURRENCY_RATES_ALL_STORE', currencies.data))
      .catch(() => commit('SET_CURRENCY_RATES_ALL_STORE', []))
  }
}
